/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface PlayAudioActionArgs {
  filename: string;
  volume: number;
  timeoutSeconds: number;
}

export interface PlayAudioResultData {
}

export interface PlayAudioActionStateData {
}

function createBasePlayAudioActionArgs(): PlayAudioActionArgs {
  return { filename: "", volume: 0, timeoutSeconds: 0 };
}

export const PlayAudioActionArgs = {
  encode(message: PlayAudioActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.filename !== "") {
      writer.uint32(10).string(message.filename);
    }
    if (message.volume !== 0) {
      writer.uint32(21).float(message.volume);
    }
    if (message.timeoutSeconds !== 0) {
      writer.uint32(29).float(message.timeoutSeconds);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PlayAudioActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlayAudioActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.filename = reader.string();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.volume = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.timeoutSeconds = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlayAudioActionArgs {
    return {
      filename: isSet(object.filename) ? globalThis.String(object.filename) : "",
      volume: isSet(object.volume) ? globalThis.Number(object.volume) : 0,
      timeoutSeconds: isSet(object.timeoutSeconds) ? globalThis.Number(object.timeoutSeconds) : 0,
    };
  },

  toJSON(message: PlayAudioActionArgs): unknown {
    const obj: any = {};
    if (message.filename !== "") {
      obj.filename = message.filename;
    }
    if (message.volume !== 0) {
      obj.volume = message.volume;
    }
    if (message.timeoutSeconds !== 0) {
      obj.timeoutSeconds = message.timeoutSeconds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlayAudioActionArgs>, I>>(base?: I): PlayAudioActionArgs {
    return PlayAudioActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlayAudioActionArgs>, I>>(object: I): PlayAudioActionArgs {
    const message = createBasePlayAudioActionArgs();
    message.filename = object.filename ?? "";
    message.volume = object.volume ?? 0;
    message.timeoutSeconds = object.timeoutSeconds ?? 0;
    return message;
  },
};

function createBasePlayAudioResultData(): PlayAudioResultData {
  return {};
}

export const PlayAudioResultData = {
  encode(_: PlayAudioResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PlayAudioResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlayAudioResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PlayAudioResultData {
    return {};
  },

  toJSON(_: PlayAudioResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PlayAudioResultData>, I>>(base?: I): PlayAudioResultData {
    return PlayAudioResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlayAudioResultData>, I>>(_: I): PlayAudioResultData {
    const message = createBasePlayAudioResultData();
    return message;
  },
};

function createBasePlayAudioActionStateData(): PlayAudioActionStateData {
  return {};
}

export const PlayAudioActionStateData = {
  encode(_: PlayAudioActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PlayAudioActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlayAudioActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PlayAudioActionStateData {
    return {};
  },

  toJSON(_: PlayAudioActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PlayAudioActionStateData>, I>>(base?: I): PlayAudioActionStateData {
    return PlayAudioActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlayAudioActionStateData>, I>>(_: I): PlayAudioActionStateData {
    const message = createBasePlayAudioActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
